class TillerBack {
  constructor(
    provider_token,
    email,
    phone,
    firstname,
    lastname,
    name,
    companyName,
    currency,
    country,
    zipcode,
    city,
    address,
    salesforce,
  ) {
    this.provider_token = provider_token;
    this.email = email;
    this.phone = phone;
    this.firstname = firstname;
    this.lastname = lastname;
    this.name = name;
    this.companyName = companyName;
    this.currency = 'EUR';
    this.country = country;
    this.zipcode = zipcode;
    this.city = city;
    this.address = address;
    this.salesforce = salesforce;
  }
}

export default TillerBack;



// WEBPACK FOOTER //
// ./src/models/TillerBack.js